import moment from "moment";
import React, { useEffect, useState } from "react";
import SelectDropDown from "../../../shared/drop-down/drop-down";
import { confirmAlert } from "react-confirm-alert";
import { SearchOrganizationMembers } from "../../../../api";
import ResetPassword from "../../../modals/reset-password/reset-password";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faKey } from "@fortawesome/free-solid-svg-icons";
library.add(faKey);

import "react-confirm-alert/src/react-confirm-alert.css";

const MemberList = ({
    isPcAdmin,
    officesList,
    branchesList,
    RoleLabel,
    organization_user,
    showAddMemberModal,
    deleteMember,
    editMember,
    updateMemberStatus,
    loginAs,
    organizationId,
    updateMembersCount,
    subOrgs,
    user,
}) => {
    const roleOptions = [
        { label: "Enable", value: 0 },
        { label: "Disable", value: 1 },
    ];
    const roleFilterOptions = [
        { label: "All", value: "all" },
        { label: "Admin", value: "admin" },
        { label: "Agent", value: "agent" },
        { label: "Branch head", value: "branch head" },
        { label: "Office head", value: "office head" },
    ];
    const statusFilterOptions = [
        { label: "All", value: -1 },
        { label: "Enable", value: 0 },
        { label: "Disable", value: 1 },
    ];
    const [members, setOrgMembers] = useState(organization_user);
    const [roleFilter, setRoleFiler] = useState("all");
    const [statusFilter, setStatusFilter] = useState(-1);
    const [searchValue, setSearchedValue] = useState("");
    const [showResetPasswordModel, setShowAddTeamplateModel] = useState(false);
    const [selectedMenberId, setSelectedMenberId] = useState("");
    const [searchBySubOrg, setSearchBySubOrg] = useState(null);
    const [subOrgDropdown, setSubOrgDropdown] = useState([]);

    useEffect(() => {
        let subOrgTemp = [];
        subOrgTemp.push({ value: "", label: "ALL" });
        subOrgs.map((item) => {
            subOrgTemp.push({ value: item.id, label: item.sub_org_name });
        });
        setSubOrgDropdown(subOrgTemp);
    }, [subOrgs]);
    useEffect(() => {
        setOrgMembers(organization_user);
    }, [organization_user]);

    const searchMembers = (searchValue) => {
        try {
            if (organization_user.length) {
                if (searchValue !== "") {
                    setOrgMembers([]);
                    SearchOrganizationMembers(organizationId, {
                        q: searchValue,
                        sub_org: searchBySubOrg,
                    })
                        .then((response) => {
                            if (response.success) {
                                let organization_user = response.users;

                                setOrgMembers(organization_user);
                                updateMembersCount(organization_user.length);
                            }
                        })
                        .catch((error) => console.log(error));
                } else {
                    setOrgMembers([]);
                    SearchOrganizationMembers(organizationId, {
                        sub_org: searchBySubOrg,
                    })
                        .then((response) => {
                            if (response.success) {
                                let organization_user = response.users;

                                setOrgMembers(organization_user);
                                updateMembersCount(organization_user.length);
                            }
                        })
                        .catch((error) => console.log(error));
                    setOrgMembers(organization_user);
                    updateMembersCount(organization_user.length);
                }
            }
        } catch (err) {}
        setSearchedValue(searchValue);
    };

    const handleKeywordChange = (evt) => {
        if (evt.target.value.length >= 1) {
            searchMembers(evt.target.value);
        } else if (evt.target.value.length == 0) {
            setOrgMembers(organization_user);
            setSearchedValue("");
        }
    };

    const handleSearchClick = (evt) => {
        evt.preventDefault();
        if (searchValue !== "") searchMembers(searchValue);
    };

    const handleKeyDown = (evt) => {
        if (evt.key === "Enter") {
            evt.preventDefault();
        }
    };

    const handleStatusChangeFilter = (evt) => {
        if (evt === -1 && roleFilter === "all") {
            setOrgMembers(organization_user);
            updateMembersCount(organization_user.length);
        } else {
            if (evt !== -1 && roleFilter !== "all") {
                let filtered = organization_user.filter(function (mem) {
                    return mem.role === roleFilter && mem.disabled === evt;
                });
                setOrgMembers(filtered);
                updateMembersCount(filtered.length);
            } else {
                if (evt === -1) {
                    let filtered = organization_user.filter(function (mem) {
                        return mem.role === roleFilter;
                    });
                    setOrgMembers(filtered);
                    updateMembersCount(filtered.length);
                } else {
                    let filtered = organization_user.filter(function (mem) {
                        return mem.disabled === evt;
                    });
                    setOrgMembers(filtered);
                    updateMembersCount(filtered.length);
                }
            }
        }
        setStatusFilter(evt);
    };

    const handleRoleChangeFilter = (evt) => {
        if (evt === "all" && statusFilter === -1) {
            setOrgMembers(organization_user);
            updateMembersCount(organization_user.length);
        } else {
            if (statusFilter !== -1 && evt !== "all") {
                let filtered = organization_user.filter(function (mem) {
                    return mem.role === evt && mem.disabled === statusFilter;
                });
                setOrgMembers(filtered);
                updateMembersCount(filtered.length);
            } else {
                if (evt === "all") {
                    let filtered = organization_user.filter(function (mem) {
                        return mem.disabled === statusFilter;
                    });
                    setOrgMembers(filtered);
                    updateMembersCount(filtered.length);
                } else {
                    let filtered = organization_user.filter(function (mem) {
                        return mem.role === evt;
                    });
                    setOrgMembers(filtered);
                    updateMembersCount(filtered.length);
                }
            }
        }
        setRoleFiler(evt);
    };

    const handleMemberDelete = (evt) => {
        confirmAlert({
            title: "Delete Member",
            message: "Are you sure you want to delete the member?",
            buttons: [
                {
                    label: "Yes",
                    onClick: () => deleteMember(evt),
                },
                {
                    label: "No",
                },
            ],
        });
    };

    const bindMemberBranch = (branchId) => {
        if (branchId && branchId !== "") {
            const branch = branchId;
            let branches = "";
            if (branch && branch.length > 0) {
                branch.forEach((brnch) => {
                    const branchData = branchesList.find(
                        (x) => x.id === parseInt(brnch),
                    );
                    if (branchData) {
                        branches =
                            branches === ""
                                ? branchData.name
                                : branches + ", " + branchData.name;
                    }
                });
                return <p className="office">{branches}</p>;
            }
        }
        return "";
    };

    const bindMemberOffice = (officeId) => {
        if (officeId && officeId !== "") {
            const office = officeId;
            if (office && office.length > 0) {
                let offices = "";
                if (office && office.length > 0) {
                    office.forEach((offc) => {
                        const officeData = officesList.find(
                            (x) => x.id === parseInt(offc),
                        );
                        if (officeData) {
                            offices =
                                offices === ""
                                    ? officeData.name
                                    : offices + ", " + officeData.name;
                        }
                    });
                    return <p className="branch">{offices}</p>;
                }
            }
        }
        return "";
    };
    const handleShowHideModel = (show) => {
        setShowAddTeamplateModel(show);
    };
    const handleShowModel = (menberId) => {
        setSelectedMenberId(menberId);
        setShowAddTeamplateModel(true);
    };

    useEffect(() => {
        searchMembers("");
    }, [searchBySubOrg]);

    const handleSubOrgChange = (event) => {
        setSearchBySubOrg(event);
    };

    return (
        <>
            <div className="panel-heading" id="pannel-headingId">
                <div className="header-search">
                    <form>
                        <input
                            type="text"
                            placeholder="Search Member"
                            name="search"
                            className="search-box basic-multi-select"
                            onChange={(evt) => handleKeywordChange(evt)}
                            onKeyDown={(evt) => handleKeyDown(evt)}
                        />
                        <button onClick={(e) => handleSearchClick(e)}>
                            <i className="fa fa-search"></i>
                        </button>
                    </form>
                </div>
                {user?.role == "admin" && user.sub_org_id == null ? (
                    <div className="search-sub-org">
                        <SelectDropDown
                            options={subOrgDropdown}
                            name="Sub Org"
                            placeholder="Select Sub Org"
                            handleChange={(selected) => {
                                handleSubOrgChange(selected.value);
                            }}
                        />
                    </div>
                ) : (
                    ""
                )}
                <div className="d-flex">
                    <button
                        onClick={() => showAddMemberModal()}
                        className="orgbtn"
                    >
                        <i className="fa fa-create"></i> Add Member
                    </button>
                </div>
            </div>
            <div className="table-organizations">
                <table
                    className="table table-striped table-responsive"
                    id="organization-index-table"
                >
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Contacts</th>
                            <th className="headRoll">
                                <span>Role</span>
                                <SelectDropDown
                                    options={roleFilterOptions}
                                    name="member_role_filter"
                                    placeholder="Status"
                                    value={roleFilter}
                                    handleChange={(selected) => {
                                        handleRoleChangeFilter(selected.value);
                                    }}
                                />
                                <div></div>
                            </th>

                            <th>Joining date</th>
                            <th className="headAvailbility">
                                <span>Availability</span>
                                <SelectDropDown
                                    options={statusFilterOptions}
                                    name="member_status_filter"
                                    placeholder="Status"
                                    value={statusFilter}
                                    handleChange={(selected) => {
                                        handleStatusChangeFilter(
                                            selected.value,
                                        );
                                    }}
                                />
                            </th>

                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {members && members.length > 0 ? (
                            members.map((member, index) => (
                                <tr key={"tr" + index}>
                                    <td>{member.id}</td>
                                    <td className="contactTd">
                                        <div className="org-full-name">
                                            <h4>{member.name}</h4>
                                        </div>
                                        <div className="contactPH">
                                            <span>
                                                <img src="/images/call.svg" />
                                                {member.phone_direct}
                                            </span>
                                        </div>
                                        <div className="contactEM">
                                            <span>
                                                <img src="/images/mail.svg" />
                                                {member.email}
                                            </span>
                                        </div>
                                    </td>
                                    <td className="tdRole-org">
                                        <p className="role">
                                            {RoleLabel(member.role)}
                                        </p>
                                        {bindMemberBranch(member.branch_id)}
                                        {bindMemberOffice(member.office_id)}
                                    </td>
                                    <td>
                                        <p>
                                            {moment(member.created_at).format(
                                                "LL",
                                            )}
                                        </p>
                                    </td>
                                    <td className="tdEnable">
                                        <SelectDropDown
                                            options={roleOptions}
                                            name="member_status"
                                            placeholder="Status"
                                            value={member.disabled}
                                            handleChange={(selected) => {
                                                updateMemberStatus(
                                                    member,
                                                    selected.value,
                                                );
                                            }}
                                        />
                                    </td>
                                    <td className="addresidual">
                                        <span
                                            onClick={(evt) =>
                                                editMember(member)
                                            }
                                        >
                                            Edit
                                        </span>
                                        {isPcAdmin ? (
                                            <span
                                                onClick={(evt) =>
                                                    loginAs(member)
                                                }
                                                className="addresidualIMG"
                                            >
                                                Login As
                                            </span>
                                        ) : null}
                                        <span
                                            onClick={(evt) =>
                                                handleMemberDelete(member.id)
                                            }
                                            className="addresidualIMG"
                                        >
                                            <img src="/images/delet.svg " />
                                        </span>
                                        {isPcAdmin ? (
                                            <span
                                                onClick={(evt) =>
                                                    handleShowModel(member.id)
                                                }
                                                style={{
                                                    margin: "0px 10px",
                                                    color: "#808080b8",
                                                }}
                                            >
                                                <FontAwesomeIcon icon="key" />
                                            </span>
                                        ) : null}
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan={6}>
                                    <span>No data found</span>
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
            {showResetPasswordModel === true && (
                <ResetPassword
                    showResetPasswordModel={showResetPasswordModel}
                    handleCloseModel={(evt) => handleShowHideModel(false)}
                    menberIdSetNull={(evt) => setSelectedMenberId("")}
                    menberId={selectedMenberId}
                />
            )}
        </>
    );
};

export default MemberList;
